import React from 'react';
import { ArrowDownIcon, ArrowUpIcon, Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const HeaderWrapper = styled(Box)`
  &:hover {
    background-color: ${({ theme }) => theme.colors.module};
  }
`;

interface Props {
  testId?: string;
  isExpanded?: boolean;
  onClick?: () => void;
  enrollmentTitle?: string;
}

const AccountsListItemHeader: React.FC<Props> = ({ testId, isExpanded, onClick, enrollmentTitle }) => {
  return (
    <HeaderWrapper
      data-testId={`${testId}-account-list-item_header`}
      pad={{ horizontal: 'spacing4' }}
      direction="row"
      justify="between"
      align="center"
      round="button2Round"
      onClick={onClick}
    >
      <Text
        data-testId="account-list-item_header-title"
        title={enrollmentTitle}
        weight={isExpanded ? 700 : 400}
        className="ellipsis-text"
      >
        {enrollmentTitle}
      </Text>
      {isExpanded
        ? <ArrowUpIcon color="iconSecondary" size="24px" />
        : <ArrowDownIcon color="iconSecondary" size="24px" />}
    </HeaderWrapper>
  );
};

export default AccountsListItemHeader;
